import BaseModel from './BaseModel'
import User from './User'
import UserPermission from './UserPermission'

export default class Permission extends BaseModel {
  static entity = 'permissions'
  static primaryKey = 'permission_id'

  static fields() {
    return {
      permission_id: this.attr(null),
      name: this.string(),
      users: this.belongsToMany(User, UserPermission, 'permission_id', 'user_id'),
    }
  }
}
